<script>
  import OpenseaTrait from './opensea_trait.svelte';

  export let layout;
  export let value;

  const getImage = async value => value instanceof File ? file2base64(value) : ipfs2http(value);

  const file2base64 = file => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;

      reader.readAsDataURL(file);
    })
  }

  const ipfs2http = async ipfs => {
    if (ipfs.startsWith('ipfs://')) {
      let [cId, ...content] = ipfs.replace('ipfs://', '').split('/');
      content.unshift('');
      content = content.join('/')
      const urls = [
        `https://ipfs.lateralthink.club/ipfs/${ cId }${ content || '' }`,
        `http://localhost:8080/ipfs/${ cId }${ content || '' }`,
        `https://gateway.pinata.cloud/ipfs/${ cId }${ content || '' }`,
        `https://ipfs.io/ipfs/${ cId }${ content || '' }`,
        `https://gateway.ipfs.io/ipfs/${ cId }${ content || '' }`,
        `https://cloudflare-ipfs.com/ipfs/${ cId }${ content || '' }`,
        `https://ipfs.fleek.co/ipfs/${ cId }${ content || '' }`
      ]

      for (const url of urls) {
        try {
          let resp = await fetch(url);
          return resp.url;
        } catch {}
      }
    } else {
      return ipfs;
    }
  }
</script>

{#if layout.args?.format === 'image'}
  {#await getImage(value)}
    <img src="https://placehold.jp/cccccc/787878/650x650.png?text=Loading" alt="Loading...">
  {:then url}
    <!-- svelte-ignore a11y-missing-attribute -->
    <img src={ url }>
  {/await}
{:else if layout.args?.format === 'array'}
  {#if layout.args.widget === 'stats'}
    <div class="lt-stats vertical">
      {#each value as item}
        {#if Object.keys(item).includes('trait_type')}
          <OpenseaTrait value={ item } />
        {/if}
      {/each}
    </div>
  {/if}
{:else if layout.args?.format === 'html'}
  {@html value }
{:else}
  { value }
{/if}